import {
    GET_TEAM_RANKING_ERROR,
    GET_TEAM_RANKING_LOADING,
    GET_TEAM_RANKING_SUCCESS
} from "../../../constant/actionTypes";

const teamRankingReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_TEAM_RANKING_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }

        case GET_TEAM_RANKING_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }

        case GET_TEAM_RANKING_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }

        default:
            return state;
    }
}

export default teamRankingReducer;